const Ellips = ({ isActive }) => {
  return (
    <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="5" cy="4.5" r="4" fill={isActive ? "#eb4034" : "#526DCB"} stroke="#F0EEF6"/>
    </svg>
  );
};

export default Ellips;
